import type {QRDesignTile} from '@Components/qr-code-generator/qr-code-generator.types';

export interface QRSuggestedTemplatesProps {
  tiles: QRDesignTile[];
  /** What the row offers to put on a design; the QR tool's own wording when left out. */
  heading?: string;
  blockClasses?: string;
  gridClasses?: string;
  onTemplateSelect: (designHashedId: string) => Promise<void>;
  onBrowseAllClick: () => void;
}

export const QR_TEMPLATE_GALLERY_PATH = 'posters/gallery';
